import { MigrationReadinessReport } from 'types/MigrationReadinessReport';
import API, { AxiosRequestOptions } from './API';

const facilityMappingPath = '/api/v2/migration-readiness-report/facility-mapping';

export const getMigrationReadinessReport = async (
  options?: AxiosRequestOptions,
): Promise<MigrationReadinessReport> => {
  const response = await API.get<MigrationReadinessReport>(
    '/api/v2/migration-readiness-report',
    options,
  );
  return response.data;
};

export const setCaasMigrationFacilityMapping = async (
  facilityId: number,
  options?: AxiosRequestOptions,
): Promise<void> => {
  await API.put(facilityMappingPath, { FacilityId: facilityId }, options);
};

export const deleteCaasMigrationFacilityMapping = async (
  options?: AxiosRequestOptions,
): Promise<void> => {
  await API.delete(facilityMappingPath, options);
};
